import "./CareerBanner.css";

const CareerBanner = () => {
  const handleExploreClick = () => {
    const element = document.getElementById("open-positions");
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="career-banner-container">
      <div className="career-banner">
        <div className="career-banner__content">
          <h1 className="career-banner__title">
            What Would You Build If You Had The Space To Do It Right?
          </h1>
          <p className="career-banner__description">
            Most careers are characterized by job titles. Ours are molded by the
            problems we solve and the responsibility we take on. At Quad Theory
            Ltd, we work on real systems, make real decisions and learn by
            building things that matter. If you care about clean work, honest
            collaboration, and growing through challenge, you might feel at home
            here.
          </p>

          <button
            className="career-banner__btn-primary"
            onClick={handleExploreClick}
          >
            View Open Roles
          </button>
        </div>
        {/* <div className="career-banner__illustration"></div> */}
      </div>
      <div className="career-banner__illustration"></div>
    </div>
  );
};

export default CareerBanner;
